import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { LINKS } from "../../config/links";

const normalizePath = (pathname) => {
    if (pathname === "/") {
        return "/";
    }

    return pathname.replace(/\/+$/, "");
};

const getLanguageFromPath = (pathname) => {
    for (const localizedRoute of Object.values(LINKS.routes)) {
        if (localizedRoute?.en === pathname) {
            return "en";
        }

        if (localizedRoute?.pl === pathname) {
            return "pl";
        }
    }

    return "pl";
};

const LanguageSync = () => {
    const { pathname } = useLocation();
    const { i18n } = useTranslation();

    useEffect(() => {
        const normalizedPath = normalizePath(pathname);
        const routeLanguage = getLanguageFromPath(normalizedPath);

        const currentLanguage =
            i18n.resolvedLanguage || i18n.language;

        if (!currentLanguage?.startsWith(routeLanguage)) {
            void i18n.changeLanguage(routeLanguage);
        }
    }, [pathname, i18n]);

    return null;
};

export default LanguageSync;